/**
 * @author fris4874
 *
* */

/**
 * Action Types
*/

export const REQUEST_ALL_VENDORS_FOR_SEGMENT_DETAIL = 'REQUEST_ALL_VENDORS_FOR_SEGMENT_DETAIL';
export const RECEIVE_ALL_VENDORS_FOR_SEGMENT_DETAIL = 'RECEIVE_ALL_VENDORS_FOR_SEGMENT_DETAIL';

export const FETCH_SEGMENT_CODES = 'FETCH_SEGMENT_CODES';
export const RECIEVE_SEGMENT_CODES = 'RECIEVE_SEGMENT_CODES';

export const FETCH_SEGMENT_DETAILS = 'FETCH_SEGMENT_DETAILS';
export const RECIEVE_SEGMENT_DETAILS = 'RECIEVE_SEGMENT_DETAILS';

export const SAVE_SEGMENT_DETAILS = 'SAVE_SEGMENT_DETAILS';
export const RECIEVE_SEGMENT_DETAILS_PERSIST_STATUS = 'RECIEVE_SEGMENT_DETAILS_PERSIST_STATUS';

export const UPDATE_SEGMENT_DETAILS = 'UPDATE_SEGMENT_DETAILS';
export const RECIEVE_SEGMENT_DETAILS_UPDATE_STATUS = 'RECIEVE_SEGMENT_DETAILS_UPDATE_STATUS';

export const UPDATE_SEGMENT_DETAILS_EXISTING_COMMENTS = 'UPDATE_SEGMENT_DETAILS_EXISTING_COMMENTS';

export const DELETE_SEGMENT_DETAILS = 'DELETE_SEGMENT_DETAILS';
export const RECIEVE_SEGMENT_DETAILS_DELETE_STATUS = 'RECIEVE_SEGMENT_DETAILS_DELETE_STATUS';
export const RECIEVE_SEGMENT_DETAILS_INACTIVATE_STATUS = 'RECIEVE_SEGMENT_DETAILS_INACTIVATE_STATUS';

export const SET_SELECTED_SEGMENT_DETAIL_SUVC_ASSOCIATION = 'SET_SELECTED_SEGMENT_DETAIL_SUVC_ASSOCIATION';
export const SELECT_SEGMENT_DETAIL_SUVC_ASSOCIATION = 'SELECT_SEGMENT_DETAIL_SUVC_ASSOCIATION';
export const SELECT_SEGMENT_DETAIL_VENDOR_ASSOCIATION = 'SELECT_SEGMENT_DETAIL_VENDOR_ASSOCIATION';

export const SEGMENT_DETAIL_SEARCH_VENDORS = 'SEGMENT_DETAIL_SEARCH_VENDORS';

export const RESET_SELECTED_SEGMENT_DETAIL_SUVCS = 'RESET_SELECTED_SEGMENT_DETAIL_SUVCS';

export const RESET_SEGMENT_CODES = 'RESET_SEGMENT_CODES';

export const REVERT_SEGMENT_DETAIL_UNSAVED_VENDOR_SELECTIONS = 'REVERT_SEGMENT_DETAIL_UNSAVED_VENDOR_SELECTIONS';

export const FETCH_SEGMENT_VERSIONS = 'FETCH_SEGMENT_VERSIONS';
export const RECEIVE_SEGMENT_VERSIONS = 'RECEIVE_SEGMENT_VERSIONS';
export const SEGMENT_VERSIONS_ERROR = 'SEGMENT_VERSIONS_ERROR';
export const SET_SELECTED_VERSION = 'SET_SELECTED_VERSION';
export const RESET_SELECTED_VERSION = 'RESET_SELECTED_VERSION';

export const FETCH_SEGMENT_VENDOR_MAPPING = 'FETCH_SEGMENT_VENDOR_MAPPING';
export const RECIEVE_SEGMENT_VENDOR_MAPPING = 'RECIEVE_SEGMENT_VENDOR_MAPPING';
export const RESET_SEGMENT_DETAILS_AND_COMMENTS = 'RESET_SEGMENT_DETAILS_AND_COMMENTS';
export const SET_SELECTED_SEGMENT_CODE = 'SET_SELECTED_SEGMENT_CODE';
export const RESET_EVENT_TYPE = 'RESET_EVENT_TYPE';

export const RECEIVE_SEGMENT_DETAILS_BY_SEGMENT_VERSION = 'RECEIVE_SEGMENT_DETAILS_BY_SEGMENT_VERSION';
export const REQUEST_SEGMENT_DETAILS_BY_SEGMENT_VERSION = 'REQUEST_SEGMENT_DETAILS_BY_SEGMENT_VERSION';

/**
 * Actions
 */

export const resetSegmentDetailsAndComments = () => ({
  type: RESET_SEGMENT_DETAILS_AND_COMMENTS,
});

export const receiveAllVendorsForSegmentDetail = (data) => (
  {
    type: RECEIVE_ALL_VENDORS_FOR_SEGMENT_DETAIL,
    data
  });

export const fetchSegmentVendorMapping = (vendors, status, effectiveDate, includeAllVendors = false) => ({
  type: FETCH_SEGMENT_VENDOR_MAPPING,
  data: {
    vendors,
    status,
    effectiveDate,
    includeAllVendors,
  }
});

export const receiveSegmentVendorMapping = (data) => ({
  type: RECIEVE_SEGMENT_VENDOR_MAPPING,
  data
});

export const fetchSegmentCodes = (segmentType, vendor) => ({ type: FETCH_SEGMENT_CODES, data: { segmentType, vendor } });
export const receiveSegmentCodes = (data) => ({ type: RECIEVE_SEGMENT_CODES, data });

export const fetchSegmentDetails = (segmentType, segmentCode, segmentVersion) => ({ type: FETCH_SEGMENT_DETAILS, data: { segmentType, segmentCode, segmentVersion } });
export const receiveSegmentdetails = (data) => ({ type: RECIEVE_SEGMENT_DETAILS, data });

export const saveSegmentDetail = (data, isNewSegment) => ({ type: SAVE_SEGMENT_DETAILS, data, isNewSegment });
export const receiveSegmentDetailsPersistStatus = (data) => ({ type: RECIEVE_SEGMENT_DETAILS_PERSIST_STATUS, data });

export const updateSegmentDetail = (selectedVendorCode, segmentType, segmentCode, segmentDetails, newComment) => ({
  type: UPDATE_SEGMENT_DETAILS,
  data: {
    selectedVendorCode, segmentType, segmentCode, segmentDetails, newComment
  }
});
export const receiveSegmentDetailsUpdatetStatus = (data) => ({ type: RECIEVE_SEGMENT_DETAILS_UPDATE_STATUS, data });

export const updateSegmentDetailsExistingComments = (data) => ({ type: UPDATE_SEGMENT_DETAILS_EXISTING_COMMENTS, data });

export const deleteSegmentDetail = (
  action,
  segmentType,
  segmentCode,
  segmentVersion
) => ({
  type: DELETE_SEGMENT_DETAILS,
  data: {
    action,
    segmentType,
    segmentCode,
    segmentVersion,
  },
});

export const receiveSegmentDetailsDeleteStatus = () => ({ type: RECIEVE_SEGMENT_DETAILS_DELETE_STATUS });
export const receiveSegmentDetailsInactivateStatus = () => ({ type: RECIEVE_SEGMENT_DETAILS_INACTIVATE_STATUS });

export const setSelectedSegmentDetailSuvcAssociation = (data) => ({ type: SET_SELECTED_SEGMENT_DETAIL_SUVC_ASSOCIATION, data });

export const selectSegmentDetailSuvcAssociation = (row, value, mode) => ({
  type: SELECT_SEGMENT_DETAIL_SUVC_ASSOCIATION,
  data: {
    row, value, mode
  }
});

export const selectSegmentDetailVendorAssociation = (row, value, mode) => ({
  type: SELECT_SEGMENT_DETAIL_VENDOR_ASSOCIATION,
  data: {
    row, value, mode
  }
});

export const segmentDetailSearchVendors = (value, suvcMappingList) => ({
  type: SEGMENT_DETAIL_SEARCH_VENDORS,
  data: {
    value, suvcMappingList
  }
});

export const resetSelectedSegmentDetailSuvcs = () => (
  {
    type: RESET_SELECTED_SEGMENT_DETAIL_SUVCS
  });

export const resetSegmentcodes = () => (
  {
    type: RESET_SEGMENT_CODES
  });

export const setSelectedVersion = (version) => ({
  type: SET_SELECTED_VERSION,
  data: version,
});

export const setSelectedSegmentCode = (segmentCode) => ({
  type: SET_SELECTED_SEGMENT_CODE,
  data: segmentCode
});

export const resetSelectedVersion = () => ({
  type: RESET_SELECTED_VERSION,
});

export const resetEventType = () => ({
  type: RESET_EVENT_TYPE
});

export const revertSegmentDetailUnsavedVendorSelections = () => (
  {
    type: REVERT_SEGMENT_DETAIL_UNSAVED_VENDOR_SELECTIONS
  });

export const fetchSegmentVersions = (segmentType, segmentCode) => ({
  type: FETCH_SEGMENT_VERSIONS,
  data: { segmentType, segmentCode },
});

export const receiveSegmentVersions = (versionData) => ({
  type: RECEIVE_SEGMENT_VERSIONS,
  data: versionData,
});

export const segmentVersionsError = (error) => ({
  type: SEGMENT_VERSIONS_ERROR,
  data: error,
});

export const requestSegmentDetailsByVersion = (segmentVersion, loadVendors) => ({ type: REQUEST_SEGMENT_DETAILS_BY_SEGMENT_VERSION, data: { segmentVersion, loadVendors } });
export const receiveSegmentDetailsByVersion = (data) => ({ type: RECEIVE_SEGMENT_DETAILS_BY_SEGMENT_VERSION, data });
